import {
  ENTITY_LEVEL,
  ENTITY_SYNC_STATUS,
} from '../../../../common/constants/integrationConstants/crmConstants';
import {
  fetchSyncDataStatus,
  triggerSyncDataStatus,
} from '../../../routines/integrations/crmRoutines';

const initialState = {
  organizationSyncStatus: ENTITY_SYNC_STATUS.NOT_STARTED,
  accountSyncStatus: ENTITY_SYNC_STATUS.NOT_STARTED,
  contactSyncStatus: ENTITY_SYNC_STATUS.NOT_STARTED,
  loading: true,
  error: false,
};

const crmSyncDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case triggerSyncDataStatus.TRIGGER:
    case fetchSyncDataStatus.TRIGGER: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }

    case fetchSyncDataStatus.SUCCESS: {
      const data = action.payload || [];

      const findStatus = (entityLevel) => {
        const statusValue = data.find((status) => status.level === entityLevel);
        return statusValue
          ? statusValue.status
          : ENTITY_SYNC_STATUS.NOT_STARTED;
      };
      return {
        ...state,
        loading: false,
        organizationSyncStatus: findStatus(ENTITY_LEVEL.ORGANIZATION),
        accountSyncStatus: findStatus(ENTITY_LEVEL.ACCOUNT),
        contactSyncStatus: findStatus(ENTITY_LEVEL.CONTACT),
      };
    }

    case triggerSyncDataStatus.SUCCESS: {
      const { level, status } = action.payload;
      return {
        ...state,
        loading: false,
        [`${level}SyncStatus`]: status,
      };
    }

    case triggerSyncDataStatus.FAILURE:
    case fetchSyncDataStatus.FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

export default crmSyncDataReducer;
